/* eslint-disable no-undef */
import $ from "jquery";

const loadMore = () => {
    const init = () => {
        ajax();
    };

    const ajax = () => {
        $(document).on("click", "#btn-vanno", function () {
            //you can change the event listener and the selector as you wish
            const data = {
                action: themeObj.shop.action.load_more,
                nonce: themeObj.shop.nonce,
                page: 1,
                limit: 3,
            };

            $.ajax({
                type: "POST",
                url: themeObj.ajaxUrl,
                data: data,
            })
                .done(() => {
                    //your code here
                })
                .fail((response) => {
                    console.error(response);
                });
        });
    };

    init();
};

try {
    loadMore();
} catch (error) {
    console.error("loadMore", error);
}
